import { RouterNameEnum } from "@/router/router.types";
import { RouterProperties } from "@/router/routerProperties";

export const SalaryCalculations = [{
    path: "/calculations",
    redirect: "/calculations/index",
    component: (): any => import("@/UI/layouts/MainLayout.vue"),
    meta: {
        auth: true,
    },
    children: [
        {
            path: "mutualSettlements/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/MutualSettlements.vue"),
            name: RouterNameEnum.MutualSettlements,
            meta: {
                breadcrumb: [
                    { name: "Взаиморасчеты" }
                ],
                props: { source: RouterProperties.mutualSettlements }
            },
        },
        {
            path: "cosmetologCard/:id",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/CosmetologCard.vue"),
            name: RouterNameEnum.cosmetologCard,
            meta: {
                breadcrumb: [
                    { name: "Взаиморасчеты", link: "MutualSettlements" },
                    { name: "Детальная страница" }
                ],
                props: { source: RouterProperties.cosmetologCard }
            },
        },
        {
            path: "settlementPerDay/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/SettlementsPerDay.vue"),
            name: RouterNameEnum.SettlementPerDay,
            meta: {
                breadcrumb: [{ name: "Расчет за день" }],
                props: { source: RouterProperties.SettlementPerDay }
            },
        },
        {
            path: "settlementPerPeriod/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/SettlementsPerPeriod.vue"),
            name: RouterNameEnum.SettlementPerPeriod,
            meta: {
                breadcrumb: [{ name: "Расчет за период" }],
                props: { source: RouterProperties.SettlementPerPeriod }
            },
        },
        {
            path: "bonusesAndPenalties/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/BonusesAndPenalties.vue"),
            name: RouterNameEnum.BonusesAndPenalties,
            meta: {
                breadcrumb: [{ name: "Премии и штрафы" }],
                props: { source: RouterProperties.BonusesAndPenalties }
            },
        },
        {
            path: "calculationCriteria/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/CalculationCriteria.vue"),
            name: RouterNameEnum.CalculationCriteria,
            meta: {
                breadcrumb: [{ name: "Критерии расчета" }],
                props: { source: RouterProperties.CalculationCriteria }
            },
        },
        {
            path: "createNewCriteria/:id",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/CreateNewCriteria.vue"),
            name: RouterNameEnum.CreateNewCriteria,
            meta: {
                breadcrumb: [{ name: "Новый критерий" }],
                props: { source: RouterProperties.CreateNewCriteria }
            },
        },
        {
            path: "calculationSchemes/:Studio",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/CalculationSchemes.vue"),
            name: RouterNameEnum.CalculationSchemes,
            meta: {
                breadcrumb: [{ name: "Схемы расчета" }],
                props: { source: RouterProperties.CalculationSchemes }
            },
        },
        {
            path: "createNewRule/:id",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/CreateNewRule.vue"),
            name: RouterNameEnum.CreateNewRule,
            meta: {
                breadcrumb: [{ name: "Новое правило" }],
                props: { source: RouterProperties.CreateNewRule }
            },
        },
        {
            path: "newScheme/",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/NewScheme.vue"),
            name: RouterNameEnum.NewScheme,
            meta: {
                breadcrumb: [
                    { name: "Схема расчета", link: "CalculationSchemes" },
                    { name: "Новая схема" }
                ],
                props: { source: RouterProperties.NewScheme }
            },
        },
        {
            path: "wageCalculationScheme/",
            component: (): any => import("@/UI/pages/SalaryСalculations/Pages/WageCalculationScheme.vue"),
            name: RouterNameEnum.WageCalculationScheme,
            meta: {
                breadcrumb: [{ name: "Схема расчета зарплат" }],
                props: { source: RouterProperties.WageCalculationScheme }
            },
        },
    ]
}]